import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import WithMotion from "../utils/withMotion";
import { Loader } from "../components/Loader";
import { ActionTypes } from "../store/types";

import totalScore from "../assets/headlines/total-score.png";
import bigWinHeadline from "../assets/headlines/big-win.png";
import epicFailHeadline from "../assets/headlines/epic-fail.png";

import { ShareButtons } from "../components/ShareButtons";
import scss from "./Share.module.scss";
import { characters } from "../data/characters";

//Utils
import { formatNumberWithCommas } from "../utils/utils";

const Share = () => {
  const dispatch = useDispatch();
  const { squadSubmission, score } = useSelector((state: any) => state);
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!score) {
      axios
        .get(`/get_score`, {
          params: { id },
        })
        .then(({ data }) => {
          dispatch({ type: ActionTypes.SET_SCORE, payload: data });
        })
        .catch((err) => {
          if (err.response.status === 404) {
            history.push("/");
          } else {
            console.error(err);
            history.push("/");
          }
        });
    }
    // eslint-disable-next-line
  }, []);

  if (!score) {
    return <Loader />;
  }

  const { bigWin, epicFail } = score;
  const cityRank = score.rankings.city.rank;
  const globalRank = score.rankings.global.rank;

  return (
    <main>
      {squadSubmission && (
        <h2 className={scss.instruction}>
          SHARE YOUR WIN (Or FAIL) on SOCIAL, TAG YOUR FRIENDS, AND CHALLENGE
          THEM TO BEAT YOUR SCORE.
        </h2>
      )}
      {squadSubmission?.entryId === id && <ShareButtons />}
      <div>
        <section className={scss.scoreBox}>
          <img className={scss.headline} src={totalScore} alt="total score" />
          <div className={scss.score}>
            <span>{formatNumberWithCommas(score.totalPoints)}</span>
            <label>PTS</label>
          </div>
          <div className={scss.rightHalf}>
            <label>RANK</label>
            <div className={scss.scores}>
              <div className={scss.labels}>
                <div>
                  <label>CITY</label>
                </div>
                <div>
                  <label>GLOBAL</label>
                </div>
              </div>
              <div className={scss.rank}>
                <div className={scss.rankings}>
                  <div>
                    <span className={scss.half}>#</span>
                    <span className={scss.percentile}>
                      {formatNumberWithCommas(cityRank)}
                    </span>
                  </div>
                  <div>
                    <span className={scss.half}>#</span>
                    <span className={scss.percentile}>
                      {formatNumberWithCommas(globalRank)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className={scss.bigWin}>
        <img className={scss.headline} src={bigWinHeadline} alt="big win" />
        <div className={scss.achievementDetail}>
          <div className={scss.imgWrapper}>
            <img alt="big win" src={characters[bigWin.characterId]?.icon} />
          </div>
          <div className={scss.textBox}>
            <h3>{bigWin.category}</h3>
            <p>{bigWin.name}</p>
          </div>
        </div>
      </div>
      <div className={scss.epicFail}>
        <img className={scss.headline} src={epicFailHeadline} alt="epic fail" />
        <div className={scss.achievementDetail}>
          <div className={scss.imgWrapper}>
            <img alt="epic fail" src={characters[epicFail.characterId]?.icon} />
          </div>
          <div className={scss.textBox}>
            <h3>{epicFail.category}</h3>
            <p>{epicFail.name}</p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default WithMotion(Share);
